function FeaturesSection() {
  const { SectionEyebrow } = window.AppComponents;
  const features = [
    {
      title: "One dashboard",
      copy: "Manage quotes, renewals, nominees, and documents in one place.",
    },
    {
      title: "Advisor backed",
      copy: "Reach trained experts for claims, tax questions, and plan changes.",
    },
    {
      title: "Coverage-first filters",
      copy: "Sort by claim support, add-ons, hospital network, or premium range.",
    },
  ];

  return (
    <section className="grid gap-6 py-9 lg:grid-cols-[0.8fr_1.2fr] lg:items-start">
      <div>
        <SectionEyebrow>Why people switch</SectionEyebrow>
        <h2 className="mt-4 font-display text-4xl font-bold tracking-[-0.05em] text-ink md:text-5xl">
          Clean comparisons, practical advice, and no confusing fine print.
        </h2>
        <p className="mt-4 text-base leading-8 text-slate-500">
          We bring together smart insurer discovery, simple product education,
          and high-touch service so people can buy with confidence.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        {features.map((feature) => (
          <article
            key={feature.title}
            className="rounded-3xl border border-white/80 bg-white/80 p-6 shadow-glow backdrop-blur-xl"
          >
            <strong className="block text-lg">{feature.title}</strong>
            <p className="mt-3 leading-7 text-slate-500">{feature.copy}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

window.AppSections = window.AppSections || {};
window.AppSections.FeaturesSection = FeaturesSection;
